import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from 'lodash';

import {
    deleteCommentToModerate,
    deleteStatusCommentToModerate,
    updateCommentToModerate,
    updateStatusCommentToModerate
} from "../../../../creators/user.comment.to-moderate";

import {fetchCommentsToModerate, resetCommentsToModerate} from "../../../../creators/user.comments.to-moderate";

import CommentToModerate from "./CommentToModerate";
import {PageLoader, SpinLoader} from "../../../components/Loader";


class DisplayComments extends React.Component {
    constructor(props) {
        super(props);
        this.filter = {
            page: 1,
            limit: 10,
            sort: "-createdAt",
        };

        this.state = {
            isNextComment: false,
            showSubComment: 0,
            filter: this.filter
        };
        this.fetchComments = this.fetchComments.bind(this);
        this.commentsNext = this.commentsNext.bind(this);

        this.fetchComments(this.state.filter);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.parentId !== this.props.parentId) {
            this.props.resetCommentsToModerate();
            this.fetchComments(this.state.filter, false);
        }
    }

    componentWillUnmount() {
        this.props.resetCommentsToModerate();
    }


    fetchComments(filter, more) {
        filter = {...filter};
        this.props.fetchCommentsToModerate(this.props.parentKind, this.props.parentId, filter, more);
    }

    commentsNext() {
        let page = this.state.filter.page + 1;
        let newFilter = {...this.state.filter, page};
        this.setState({filter: newFilter});
        this.fetchComments(newFilter, true);
    }

    acceptCommentToModerate(id, value) {
        if(this.props.parentKind === "status"){
            this.props.updateStatusCommentToModerate(this.props.ownerId, this.props.parentKind, this.props.parentId, id, {isApproved: value});
        } else {
            this.props.updateCommentToModerate(this.props.parentKind, this.props.parentId, id, {isApproved: value});
        }
    }

    deleteCommentToModerate(id) {
        if(this.props.parentKind === "status"){
            this.props.deleteStatusCommentToModerate(this.props.ownerId, this.props.parentKind, this.props.parentId, id);
        } else {
            this.props.deleteCommentToModerate(this.props.parentKind, this.props.parentId, id);
        }
    }

    render() {
        return !this.props.commentsInitialized ? <PageLoader /> : (
            <div className="column comments-container">
                <div className="comments">
                    <div className="comments-list">
                        {this.props.commentsTotal === 0 && (
                            <div className={"no-content"}>Aucun commentaire à modérer</div>
                        )}
                        {!this.props.commentsInitialized && _.times(5).map((item, index) => (
                            <CommentToModerate key={index} commentsInitialized={false}/>
                        ))}
                        {this.props.comments.map((comment) => (
                            <CommentToModerate
                                key={comment._id}
                                {...comment}
                                currentUser={this.props.currentUser}
                                parentId={this.props.parentId}
                                commentsInitialized={this.props.commentsInitialized}
                                deleteCommentToModerate={this.deleteCommentToModerate.bind(this)}
                                acceptCommentToModerate={this.acceptCommentToModerate.bind(this)}
                            />
                        ))}
                        {!this.props.commentsLoading && this.props.commentsMore && (
                            <div className="more-comments" onClick={() => this.commentsNext()}>
                                Voir plus de commentaires
                            </div>
                        )}
                        {this.props.commentsLoading && this.props.commentsMore && (
                            <div className="more-comments loading" onClick={() => this.commentsNext()}>
                                <SpinLoader className={"small"}/>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        comments: state.commentsToModerate.data,
        commentsLoading: state.commentsToModerate.loading,
        commentsInitialized: state.commentsToModerate.initialized,
        commentsTotal: state.commentsToModerate.total,
        commentsMore: state.commentsToModerate.more,

        // comment: state.commentToModerate.data,
        // commentLoading: state.commentToModerate.loading,

        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCommentsToModerate,
    resetCommentsToModerate,

    updateCommentToModerate,
    deleteCommentToModerate,
    updateStatusCommentToModerate,
    deleteStatusCommentToModerate
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DisplayComments);
